import {isChunkLoadError, reloadForChunkError} from 'common/helpers/chunkLoad'
import {Component, FC, ReactNode} from 'react'

import {toAbsoluteUrl} from '_metronic/helpers'

const Error500: FC = () => {
  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid'>
        <div className='d-flex flex-column flex-center text-center p-10'>
          <div className='card card-flush  w-lg-650px py-5'>
            <div className='card-body py-15 py-lg-20'>
              <h1 className='fw-bolder fs-2qx text-gray-900 mb-4'>System Error</h1>

              <div className='fw-semibold fs-6 text-gray-500 mb-7'>
                Something went wrong! Please try again later.
              </div>

              <div className='mb-11'>
                <img
                  src={toAbsoluteUrl('media/auth/500-error.png')}
                  className='mw-100 mh-300px theme-light-show'
                  alt=''
                />
                <img
                  src={toAbsoluteUrl('media/auth/500-error-dark.png')}
                  className='mw-100 mh-300px theme-dark-show'
                  alt=''
                />
              </div>

              <div className='mb-0'>
                <button
                  type='button'
                  className='btn btn-sm btn-primary'
                  onClick={() => window.location.reload()}
                >
                  Refresh page
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

class ChunkErrorBoundary extends Component<{children: ReactNode}, {hasError: boolean}> {
  constructor(props: {children: ReactNode}) {
    super(props)
    this.state = {hasError: false}
  }

  static getDerivedStateFromError(error: Error) {
    console.error(error)
    // Only show refresh for chunk load errors
    return {hasError: isChunkLoadError(error)}
  }

  componentDidCatch(error: Error) {
    // A stale chunk usually just means the tab is running an older build — reload
    // once (within budget) to pick up the current index.html
    if (isChunkLoadError(error)) {
      reloadForChunkError('ChunkErrorBoundary')
    }
  }

  render() {
    if (this.state.hasError) {
      return <Error500 />
    }
    return this.props.children
  }
}

export default ChunkErrorBoundary
